import { render, staticRenderFns } from "./PostFormContactInfo.vue?vue&type=template&id=40eac128&scoped=true&"
import script from "./PostFormContactInfo.vue?vue&type=script&lang=js&"
export * from "./PostFormContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eac128",
  null
  
)

export default component.exports